/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box } from '@material-ui/core';
import clsx from 'clsx';

import useStyles from './useStyles';

export const TabsRounded = ({
  data,
  defaultValue,
  onChange,
  classesNames,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(defaultValue);
  const onChangeTabs = (event, newValue) => {
    setValue(newValue);
    onChange(event, newValue);
  };
  return (
    <Box className={classes.container}>
      <Tabs
        value={value}
        onChange={onChangeTabs}
        className={classes.tabs}
        variant="fullWidth"
      >
        {
          data.map(({
            label,
            value: tabValue,
            disabled,
          }, index) => (
            <Tab
              className={clsx(classes.tab, {
                [classes.firstTab]: index === 0,
                [classes.lastTab]: index === data.length - 1,
                [classesNames?.tab]: classesNames?.tab,
              })}
              label={label}
              value={tabValue}
              disabled={disabled}
              classes={{
                selected: clsx(classes.selected, {
                  [classesNames?.selected]: classesNames?.selected,
                }),
              }}
            />
          ))
        }
      </Tabs>
    </Box>
  );
};

TabsRounded.propTypes = {
  data: PropTypes.array,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  classesNames: PropTypes.object,
};

TabsRounded.defaultProps = {
  data: [],
  defaultValue: '',
  onChange: () => { },
  classesNames: {},
};
